import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, SectionHeader } from './ui/Section';
import { resultBenefits } from '../data/content';
export function ResultsSection() {
  return <Section tone="dark" className="py-14 sm:py-16 lg:py-20" data-id="element-133" data-mp="zpgxuqhoxi3v">
      <SectionHeader tone="dark" title="Con esta guía vas a poder…" data-id="element-134" data-mp="zn4eqa0751p8" />

      <ul className="mx-auto mt-9 grid max-w-[46rem] grid-cols-1 gap-2.5 sm:mt-11 sm:grid-cols-2" data-id="element-135" data-mp="14mz7yk7g23dg">
        {resultBenefits.map(benefit => <li key={benefit} className="flex items-start gap-3 rounded-lg border border-polar/12 bg-white/[0.04] px-4 py-3" data-id="element-136" data-mp="6yfd89v8aucy">
            <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-caribe" strokeWidth={3} aria-hidden="true" data-id="element-137" data-mp="gyzhzmhyigzx" />
            <span className="font-sans text-[12.5px] leading-snug text-polar/85 sm:text-[13px]" data-id="element-138" data-mp="lpy1euy8rv7e">
              {benefit}
            </span>
          </li>)}
      </ul>

      <p className="mx-auto mt-10 max-w-[40rem] text-center font-display text-[19px] font-bold italic leading-snug text-travertino sm:mt-12 sm:text-[24px]" data-id="element-139" data-mp="3kdlorwql4j7o">
        El objetivo no es que viajes siguiendo reglas. Es que tengas la información necesaria para
        tomar mejores decisiones.
      </p>
    </Section>;
}